export default `#ifdef GL_ES
precision highp float;
precision highp int;
#endif

#include <common>
#include <clipping_planes_pars_fragment>

uniform sampler2D texture1;
uniform bool displayClasses;
uniform bool applyShading;
uniform vec3 lightDirection;
uniform float opacity;

varying float vClassification;
varying vec4 vColor;
varying vec3 vNormal;

void main() {
  #include <clipping_planes_fragment>

  if (displayClasses) {
    vec4 texture = texture2D(texture1, vec2(vClassification / 67.0, 0.0));

    if (applyShading) {
      gl_FragColor = vec4(texture.rgb, texture.a);
    } else {
      float grayScale = ((vColor.r + vColor.g + vColor.b) / 3.0 + 1.0) / 2.0;
      gl_FragColor = vec4(grayScale * texture.rgb, texture.a);
    }
  } else {
    gl_FragColor = vec4(vColor.rgb, 1.0);
  }

  if (applyShading) {
    float diffuse_lighting = max(dot(vNormal, lightDirection), 0.25);
    gl_FragColor = vec4(diffuse_lighting * gl_FragColor.rgb, gl_FragColor.a);
  }

  gl_FragColor.a *= opacity;
}`